import TurmasIndexPage from "@/Pages/Turmas/index.vue";
import NewEditTurmaPage from "@/Pages/Turmas/NewEditTurmaPage.vue";
import TurmasViewPage from "@/Pages/Turmas/view.vue";
// Métricas
import TurmasDashboard from "@/Pages/Turmas/dashboard.vue";

export default [
  {
    path: "/turmas/",
    name: "turmas",
    component: TurmasIndexPage,
  },
  {
    path: "/turmas/create",
    name: "turmas.create",
    component: NewEditTurmaPage,
    props: { editing: false },
  },
  {
    path: "/turmas/edit/:turma_id",
    name: "turmas.edit",
    component: NewEditTurmaPage,
    props: { editing: true },
  },
  {
    path: "/turmas/view/:turma_id",
    name: "turmas.view",
    component: TurmasViewPage,
  },
  // Métricas
  {
    path: "/turmas/:id/metricas",
    name: "turmas.dashboard",
    component: TurmasDashboard,
  },
];
